import { ImagePropertiesParams, RenderingProps } from '@/shared/shared.types';
import { BiographyDirectoryFields } from '@/shared/BiographyItem.types';

export type C56BiographyGridProps = RenderingProps<BiographyDirectoryFields, BiographyGridParams>;

type BiographyGridParams = {
  GridNumberOfColumns?: string;
  HeadlineTag?: string;
} & ImagePropertiesParams;
